import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SecurityInfoDialogComponent } from '../../dialog/security-info-dialog/security-info-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CompanyBranding } from '../../../branding/branding.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BrandingService } from '../../../../core/branding/branding.service';

declare global {
  interface Window {
    Trustpilot: any;
  }
}

/**
 * Year placeholder stored in tbl_company_brandings.portal_bottom_footer_text. The email pipeline
 * substitutes it in TemplateTransform.BrandingFooterFilter; the portal binds the column raw through
 * [innerHTML] and substituted nothing, so it has been printing the literal glyph since 4.11.
 * The two substitutions are duplicated with nothing keeping them in sync — change one, change both.
 */
export const PORTAL_FOOTER_YEAR_TOKEN = '&#9955;';

@UntilDestroy()
@Component({
    selector: 'ifc-app-footer',
    templateUrl: './app-footer.component.html',
    styleUrls: ['./app-footer.component.scss'],
    standalone: false
})
export class AppFooterComponent implements OnInit, AfterViewInit {

  @ViewChild('trustpilotWrapper') trustpilotWrapper: ElementRef;
  private trustpilotInitialized: boolean;

  data: any;
  currentYear: number;
  branding: CompanyBranding

  constructor(
    private router: ActivatedRoute,
    private dialog: MatDialog,
    private brandingService: BrandingService) { }

  ngOnInit() {
    this.router.data.pipe(untilDestroyed(this)).subscribe(data => this.data = data);
    this.currentYear = (new Date()).getFullYear();
    this.initBrandingInfo();
  }

  ngAfterViewInit(): void {
    this.initializeTrustpilot();
  }

  private initBrandingInfo(): void {
    this.brandingService.getBranding$()
      .pipe(untilDestroyed(this))
      .subscribe((branding: CompanyBranding) => {
        this.branding = branding;
        this.initializeTrustpilot();
      });
  }

  private initializeTrustpilot(): void {
    if (!this.trustpilotInitialized && this.trustpilotWrapper?.nativeElement && this.branding) {
      if (!this.branding.trustpilotHtml)
        this.trustpilotWrapper.nativeElement.display = 'none';
      else {
        this.trustpilotWrapper.nativeElement.innerHTML = this.branding?.trustpilotHtml;

        const trustbox = this.trustpilotWrapper.nativeElement.firstChild;
        window.Trustpilot.loadFromElement(trustbox);
      }

      this.trustpilotInitialized = true;
    }
  }

  get bottomFooterText(): string {
    return this.branding?.portalBottomFooterText?.split(PORTAL_FOOTER_YEAR_TOKEN).join(`${this.currentYear}`);
  }

  openDialog() {
    SecurityInfoDialogComponent.show(this.dialog);
  }
}
